"use client";

import ProjectLogo from "@/components/fancy/project-logo";
import Divider from "@/components/layout/divider";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Minus } from "lucide-react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import EmailOTPAuthFlow from "./email-otp-auth-flow";
import OAuthFlow from "./oauth-flow";

// INFO: if we later need to use this component somehwhere where passing searchParams is not possible, we'll have to convert it to a client component and use useSearchParams() instead

export default function SignInCard() {
  const searchParams = useSearchParams();

  // INFO: we need to re-construct/re-encode the url because useSearchParams gives decoded version of search param, %2Fdashboard -> /dashboard

  const redirectUrl = searchParams.get("redirect_url");
  const signUpPageUrl = `/sign-up${redirectUrl ? `?redirect_url=${encodeURIComponent(redirectUrl)}` : ""}`;

  return (
    <Card className="max-w-md overflow-hidden md:max-w-3xl">
      <CardContent className="grid grid-cols-1 gap-8 space-y-3 border-b md:grid-cols-2">
        <div>
          <CardHeader className="text-center">
            <div className="mx-auto w-fit py-4">
              <ProjectLogo iconStyles="size-14 md:size-14" />
            </div>

            <CardTitle className="text-lg">Welcome back 👋</CardTitle>
            <CardDescription className="text-[13px] opacity-90">Let&apos;s quickly sign you in</CardDescription>
          </CardHeader>

          <EmailOTPAuthFlow />
        </div>

        <div>
          <Divider containerStyles="py-4 pb-6">
            <p className="text-xs uppercase">or continue with</p>
          </Divider>

          <OAuthFlow />
        </div>
      </CardContent>

      <CardFooter className="flex flex-col divide-y bg-background p-0">
        <div className="w-full py-5">
          <div className="mx-auto flex w-fit items-center gap-1 text-[13px]">
            <p>Don&apos;t have an account?</p>
            <Link href={signUpPageUrl} className="cursor-pointer font-semibold hover:underline">
              Sign up
            </Link>
          </div>
        </div>
        <div className="w-full py-4">
          <Minus className="mx-auto opacity-70" />
        </div>
      </CardFooter>
    </Card>
  );
}
